import React from 'react';
import { extractDominantColor } from '../../../shared/utils/extractDominantColor';
import {
  makeHeroFallbackAccentPalette,
  makeHeroAccentPaletteFromRgb,
} from '../../../shared/utils/color';

export default function useProgramHeroPalette(imageUrl?: string | null) {
  const fallback = React.useMemo(() => makeHeroFallbackAccentPalette(), []);
  const [palette, setPalette] = React.useState(fallback);

  React.useEffect(() => {
    let active = true;

    if (!imageUrl) {
      setPalette(fallback);
      return () => {
        active = false;
      };
    }

    extractDominantColor(imageUrl).then((rgb) => {
      if (!active) return;
      setPalette(rgb ? makeHeroAccentPaletteFromRgb(rgb) : fallback);
    });

    return () => {
      active = false;
    };
  }, [imageUrl, fallback]);

  return palette;
}
